import AboutPage from "@/components/about/AboutPage"

const index = () => <AboutPage />

export default index
